var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 10.668C12.6698 10.9956 13.9993 11.8678 13.9993 12.3346M13.9993 12.3346C13.9993 12.8014 12.6698 13.6736 12.3327 14.0013M13.9993 12.3346H8.66602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 14.6654H7.15153C4.97738 14.6654 3.89031 14.6654 3.13538 14.1335C2.91908 13.9811 2.72705 13.8004 2.56513 13.5968C2 12.8862 2 11.8631 2 9.8169V8.1199C2 6.14446 2 5.15674 2.31263 4.36786C2.81521 3.09964 3.87809 2.09928 5.22557 1.62626C6.06375 1.33203 7.1132 1.33203 9.21213 1.33203C10.4115 1.33203 11.0112 1.33203 11.4901 1.50016C12.2601 1.77046 12.8675 2.3421 13.1547 3.06679C13.3333 3.51758 13.3333 4.08199 13.3333 5.21082V8.66536",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.9987C2 6.77143 2.99492 5.77648 4.22222 5.77648C4.66608 5.77648 5.18936 5.85425 5.62091 5.73862C6.00435 5.63587 6.30384 5.33638 6.40659 4.95294C6.52222 4.52139 6.44445 3.99811 6.44445 3.55425C6.44445 2.32695 7.4394 1.33203 8.66667 1.33203",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.44c0030d93db4c2c1530e570c46283d0.svg";
export { ForwardRef as ReactComponent };